import configDefault from './default';
import type { ConferenceConfig } from './types';

const wehagoConfig: ConferenceConfig = {
  ...(configDefault as ConferenceConfig),
  hosts: {
    domain: 'video.wehago.com',
    muc: 'conference.video.wehago.com',
  },
  bosh: '//video.wehago.com/http-bind',
  websocket: 'wss://video.wehago.com/xmpp-websocket',
};

export default wehagoConfig;
